function throttle(func, delay) {
  let timeoutId, lastArgs, lastThis, lastExecTime = 0;
  return function (...args) {
    lastArgs = args; lastThis = this;
    const now = Date.now();
    if (now - lastExecTime > delay) {
      func.apply(lastThis, lastArgs); lastExecTime = now;
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(lastThis, lastArgs); lastExecTime = Date.now();
      }, delay - (now - lastExecTime));
    }
  };
}


const { productHandle, productId, sectionId, mediaSize, firstVariantId, hasVariants } = (window.VTO || {});
const iframeId = `product-${sectionId}-try-on-iframe`;

const iframeVTO = document.createElement('iframe');
iframeVTO.title = 'Try On VTO';
iframeVTO.id = `try-on-iframe-vto-${sectionId}`;
iframeVTO.allow = 'camera';
iframeVTO.style.cssText = 'display: none; position:absolute;top: 0; left: 0; width: 100%; height: 100%;z-index: 2;';
iframeVTO.setAttribute('data-product-id', productId);
iframeVTO.setAttribute('data-variant-id', firstVariantId);

let activeProduct = null;

const initConfig = () => {
  return fetch('https://assets.geen.ee/projects/studson/config/config.json')
    .then((res) => res.json())
    .then((res) => {
      const config = res || [];
      activeProduct = config.find(
        (model) => String(model.metadata?.productId) === String(productId),
      );

      if (activeProduct?.metadata?.noTryOn) {
        tryOnButton.classList.add('gee-disabled');
      }
    })
    .catch(() => {});
};
initConfig();

const isVariantSupportedByConfig = (variantId) => {
  const variants =
    activeProduct?.appearance?.filter((param) => param.type === 'variant') ?? [];

  if (!variants.length) {
    if (variantId !== firstVariantId) {
      return false;
    }
    return true;
  }

  const activeVariant = variants.find((variant) => {
    const metadata = variant.value?.metadata || {};
    const availableVariantIds = [
      metadata.variantId,
      metadata.mlVariantId,
      metadata.lxlVariantId,
    ].filter(Boolean);
    return availableVariantIds.includes(variantId);
  });

  if (!activeVariant) {
    return false;
  }
  return true;
};

const isVariantHasTryOn = (variantId) => {
  let res = true;
  if (activeProduct) {
    res = isVariantSupportedByConfig(variantId);
  };
  return res;
};

const onVTOButtonClick = () => {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant') || String(firstVariantId || '');
    iframeVTO.src = `https://projects.geen.ee/studson/?product=${productId}&variant=${variantId}&mode=ar`;
    iframeVTO.style.display = 'flex';
    const carousel = document.querySelector('flickity-carousel');
    carousel.append(iframeVTO);
}

document.addEventListener('DOMContentLoaded', () => {
  const VTO_BUTTON = document.getElementById('gee-try-on-button');
  VTO_BUTTON.onclick = onVTOButtonClick;

  // TODO: mb will be useless after adding config
  window.addEventListener('message', (event) => {
      if (event.data?.type === 'TRY_ON_DISABLED') {
        if (event.data?.payload){
          VTO_BUTTON.classList.add('gee-disabled');
        }
      }      
    });

  document.addEventListener('flickity:slide-changed', (e) => {
    iframeVTO.style.display = 'none';
    const tryOnFrame = document.getElementById(iframeId);
    if (e.detail > 0) {
      VTO_BUTTON.style.display = 'flex';
      tryOnFrame.style.display = 'none';
    } else {
      VTO_BUTTON.style.display = 'none';
      tryOnFrame.style.display = 'block';
    }
  });

  let initialized = !hasVariants;
  const createVTO = async function (force) {
    if (document.getElementById(iframeId)) return;
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant') || String(firstVariantId || '');
    if (!isVariantHasTryOn(variantId)){
      return;
    }
    const flickityCarousel = document.getElementById(`product-${sectionId}-${productId}-media-list`);
    if (!flickityCarousel) return;

    const slider = document.querySelector('.flickity-slider') ?? flickityCarousel;

    if (slider){
      if (!force && !initialized) {
        initialized = true;
        return;
      }
      addTryOnSlide(slider, sectionId, productId);
      addTryOnThumbnail(sectionId, productId);
      addTryOnDot(sectionId, productId);

      const flickity = await flickityCarousel.flickity;
      if (flickity) {
        flickity.reloadCells();
        flickity.selectCell(1, false, true);
        flickity.selectCell(0, false, true);
      }
    };
  }
  if (Number(mediaSize) > 1) {
    document.addEventListener('flickity:ready', () => createVTO());
  } else {
    const flickityCarousel = document.getElementById(`product-${sectionId}-${productId}-media-list`);
    if (flickityCarousel && typeof flickityCarousel._createFlickity === 'function') {
      flickityCarousel._createFlickity().then(async ()=> await createVTO(true));
    } else {
      createVTO(true);
    }
  }
});

function addTryOnSlide(carousel, sectionId, productId) {
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get('variant') || String(firstVariantId || '');

  const tryOnSlide = document.createElement('div');
  tryOnSlide.id = iframeId;
  tryOnSlide.className = 'product__media-item is-initial-selected is-selected';
  tryOnSlide.setAttribute('data-media-type', 'iframe');
  tryOnSlide.setAttribute('data-media-id', 'iframe-999999');
  tryOnSlide.setAttribute('data-original-position', '-1');
  const src = `https://projects.geen.ee/studson/?product=${productId}&variant=${variantId}`;

  tryOnSlide.innerHTML = `
    <div class="product__media-image-wrapper aspect-ratio aspect-ratio--natural" style="padding-bottom: 100%; --aspect-ratio: 1">
      <iframe
        title="Try On"
        id="try-on-iframe-${sectionId}"
        src="${src}"
        allow="camera"
        style="width:100%;height:100%;border:none;position:absolute;top:0;left:0;"
        data-product-id="${productId}"
        data-variant-id="${variantId}">
      </iframe>
    </div>
  `;
  carousel.prepend(tryOnSlide);
}

function addTryOnThumbnail(sectionId, productId) {
  const thumbnailContainer = document.querySelector('.product__thumbnail-list-inner');
  if (!thumbnailContainer) return;
  if (thumbnailContainer.querySelector('[data-media-id="iframe-999999"]')) return;

  const tryOnThumbnail = document.createElement('button');
  tryOnThumbnail.type = 'button';
  tryOnThumbnail.tabIndex = -1;
  tryOnThumbnail.className = 'product__thumbnail-item';
  tryOnThumbnail.setAttribute('aria-current', 'true');
  tryOnThumbnail.setAttribute('aria-controls', `product-${sectionId}-try-on-iframe`);
  tryOnThumbnail.setAttribute('data-media-id', 'iframe-999999');
  tryOnThumbnail.setAttribute('data-action', 'select');

  const firstThumbnail = thumbnailContainer.querySelector('.product__thumbnail-item');
  if (firstThumbnail && firstThumbnail.classList.contains('hidden-pocket')) {
    tryOnThumbnail.classList.add('hidden-pocket');
  }

  tryOnThumbnail.innerHTML = `
    <div class="product__thumbnail" style="position:relative;background:#fff;color:#000;aspect-ratio:1;">
      <div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9966 0.770978C14.2425 0.0763396 15.7573 0.0763412 17.0032 0.770979L28.7512 7.32128C29.2116 7.57799 29.625 7.88299 29.625 8.47287V23.5035C29.6332 23.9132 29.414 24.3156 29.0329 24.5217L17.0033 31.229C15.7575 31.9237 14.2426 31.9237 12.9967 31.229L0.968514 24.5225C0.780725 24.4213 0.624883 24.2681 0.520082 24.0821C0.424272 23.9121 0.371292 23.7119 0.375 23.5059V8.47287C0.375 7.88318 0.788247 7.57794 1.24858 7.32128L12.9966 0.770978ZM2.625 22.8629L13.875 29.1355V16.6581C13.8244 16.634 13.7744 16.6082 13.7251 16.5807L2.625 10.3917V22.8629ZM16.125 29.1355L27.375 22.8629V10.3916L16.2747 16.5807C16.2254 16.6082 16.1755 16.6339 16.125 16.658V29.1355ZM15.9105 2.74495C15.3442 2.4292 14.6556 2.4292 14.0893 2.74495L3.81642 8.47276L14.8178 14.6067C14.931 14.6699 15.0688 14.6699 15.182 14.6067L26.1834 8.47276L15.9105 2.74495Z" fill="black"/>
        </svg>
      </div>
    </div>
  `;
  thumbnailContainer.prepend(tryOnThumbnail);
}

function addTryOnDot(sectionId, productId) {
  const dotsContainer = document.querySelector('.dots-nav.dots-nav--centered.hidden-lap-and-up');
  if (!dotsContainer) return;
  if (dotsContainer.querySelector('[data-media-id="iframe-999999"]')) return;

  const tryOnDot = document.createElement('button');
  tryOnDot.type = 'button';
  tryOnDot.tabIndex = -1;
  tryOnDot.className = 'dots-nav__item tap-area';
  tryOnDot.setAttribute('aria-current', 'true');
  tryOnDot.setAttribute('aria-controls', `product-${sectionId}-try-on-iframe`);
  tryOnDot.setAttribute('data-media-id', 'iframe-999999');
  tryOnDot.setAttribute('data-action', 'select');
  tryOnDot.innerHTML = `<span class="visually-hidden">Go to slide 1</span>`;
  dotsContainer.insertBefore(tryOnDot, dotsContainer.firstChild);
}